// Hero slider
swiper = new Swiper('.hero-slider', {
	updateOnWindowResize: true,
	centeredSlides: true,
	slidesPerColumnFill: 'row',
	slidesPerView: 1,
	spaceBetween: 0,
	speed: 2000,
	loop: true,
	autoplay: {
		delay: 5000,
		disableOnInteraction: false,
	},
	keyboard: {
		enabled: true,
		onlyInViewport: false,
	},
	navigation: {
		prevEl: '.swiper-button-prev',
		nextEl: '.swiper-button-next'
	},
	grabCursor: true
});

// Testimonials slider
swiper = new Swiper('.testimonials-slider', {
	updateOnWindowResize: true,
	centeredSlides: true,
	slidesPerColumnFill: 'row',
	slidesPerView: 1,
	spaceBetween: 15,
	speed: 2000,
	loop: true,
	breakpoints: {
		320: {
			slidesPerView: 1.4
		},
		760: {
			slidesPerView: 1.4
		},
		992: {
			slidesPerView: 3.4
		}
	},
	autoplay: {
		delay: 7000,
		disableOnInteraction: false,
	},
	keyboard: {
		enabled: true,
		onlyInViewport: false,
	},
	navigation: {
		prevEl: '.swiper-button-prev',
		nextEl: '.swiper-button-next'
	},
	grabCursor: true
});

// Related pages & posts
swiper = new Swiper('.related-pages.swiper-slider, .related-posts.swiper-slider', {
	observeSlideChildren: true,
	slideToClickedSlide: true,
	updateOnWindowResize: true,
	slidesPerView: 3,
	spaceBetween: 30,
	loop: true,
	breakpoints: {
		320: {
			slidesPerView: 1
		},
		760: {
			slidesPerView: 2
		},
		992: {
			slidesPerView: 3
		}
	},
	autoplay: {
		delay: 7000,
		disableOnInteraction: false,
	},
	keyboard: {
		enabled: true,
		onlyInViewport: false,
	},
	navigation: {
		nextEl: '.swiper-button-next',
		prevEl: '.swiper-button-prev',
	},
	grabCursor: true
});

// Default Row Slider section
$('.wp-block-wp-row-section.slider-section:not(.slider-section--norepeat) > .row').addClass('swiper-wrapper');
$('.wp-block-wp-row-section.slider-section:not(.slider-section--norepeat) > .row > .wp-block-wp-column').addClass('swiper-slide');
$('.wp-block-wp-row-section.slider-section:not(.slider-section--norepeat)').append('<div class="swiper-slider-section-nav"><div class="swiper-button-prev"></div><div class="swiper-pagination"></div><div class="swiper-button-next"></div></div>');
setTimeout(function() {
	swiper = new Swiper('.wp-block-wp-row-section.slider-section:not(.slider-section--norepeat)', {
		observeSlideChildren: true,
		slideToClickedSlide: true,
		updateOnWindowResize: true,
		slidesPerView: 1,
		spaceBetween: 0,
		loop: true,
		breakpoints: {
			320: {
				slidesPerView: 1
			},
			760: {
				slidesPerView: 2
			},
			992: {
				slidesPerView: 4
			}
		},
		speed: 5000,
		autoplay: {
			disableOnInteraction: false,
			pauseOnMouseEnter: true,
			delay: 0,
		},
		keyboard: {
			enabled: true,
			onlyInViewport: false,
		},
		pagination: {
			el: '.swiper-slider-section-nav .swiper-pagination',
			clickable: true,
		},
		navigation: {
			nextEl: '.swiper-slider-section-nav .swiper-button-next',
			prevEl: '.swiper-slider-section-nav .swiper-button-prev',
		},
		grabCursor: true
	});

}, 500);

// Default Gallery section
setTimeout(function() {
	swiper = new Swiper('.photo-gallery.swiper-slider', {
		observeSlideChildren: true,
		slideToClickedSlide: true,
		updateOnWindowResize: true,
		slidesPerView: 1,
		spaceBetween: 20,
		loop: false,
		breakpoints: {
			320: {
				slidesPerView: 1
			},
			760: {
				slidesPerView: 2
			},
			992: {
				slidesPerView: 3
			}
		},
		keyboard: {
			enabled: true,
			onlyInViewport: false,
		},
		pagination: {
			el: '.swiper-slider-section-nav .swiper-pagination',
			clickable: true,
		},
		navigation: {
			nextEl: '.swiper-slider-section-nav .swiper-button-next',
			prevEl: '.swiper-slider-section-nav .swiper-button-prev',
		},
		grabCursor: true
	});

}, 500);

// Mobile only slider
// Store swiper instances per container
const swiperInstances = new WeakMap();

function initSwiper() {
    const containers = document.querySelectorAll('.three-cards, .top-cards, .mobile-only-slider');
    if (!containers.length) return;
    
    containers.forEach(container => {
        const wrapper = container.querySelector('.row');
        if (!wrapper) return;
        
        const existingInstance = swiperInstances.get(container);
        
        // ✅ Enable Swiper only on mobile
        if (window.innerWidth <= 768 && !existingInstance) {
            // Add Swiper classes dynamically
            container.classList.add('swiper');
            wrapper.classList.add('swiper-wrapper');
            [...wrapper.children].forEach(child => child.classList.add('swiper-slide'));
    
            const prevBtn = document.createElement('div');
            prevBtn.className = 'swiper-button-prev';
            container.appendChild(prevBtn);
            
            const nextBtn = document.createElement('div');
            nextBtn.className = 'swiper-button-next';
            container.appendChild(nextBtn);
            
            const swiper = new Swiper(container, {
                centeredSlides: true,
                slidesPerView: 1.4,
                spaceBetween: 10,
                speed: 2000,
                loop: true,
                autoplay: {
                    delay: 5000,
                    disableOnInteraction: false,
                },
                keyboard: {
                    enabled: true,
                    onlyInViewport: false,
                },
                navigation: {
                    prevEl: prevBtn,
                    nextEl: nextBtn,
                },
                grabCursor: true,
            });
            
            swiperInstances.set(container, swiper);
            console.log('✅ Swiper initialized:', container);
        }
        // ❌ Destroy Swiper on desktop
        else if (window.innerWidth > 768 && existingInstance) {
            existingInstance.destroy(true, true);
            swiperInstances.delete(container);
            container.classList.remove('swiper');
            wrapper.classList.remove('swiper-wrapper');
            [...wrapper.children].forEach(child => child.classList.remove('swiper-slide'));
            
            // ✅ Remove navigation buttons
            const prevBtn = container.querySelector('.swiper-button-prev');
            const nextBtn = container.querySelector('.swiper-button-next');
            if (prevBtn) prevBtn.remove();
            if (nextBtn) nextBtn.remove();
            
            console.log('❌ Swiper destroyed:', container);
		}
	});

	// ✅ BLOG MOBILE CAROUSEL
	const blogContainer = document.querySelector('.blog-carousel');

	if (blogContainer) {
		const blogList = blogContainer.querySelector('.wp-block-latest-posts__list');
		const blogItems = blogList?.children;
		const blogInstance = swiperInstances.get(blogContainer);

		if (window.innerWidth <= 768 && !blogInstance) {

			blogContainer.classList.add('swiper');
			blogList.classList.add('swiper-wrapper');

			[...blogItems].forEach(item => {
				item.classList.add('swiper-slide');
			});

			const swiper = new Swiper(blogContainer, {
				slidesPerView: 1.2,
				spaceBetween: 16,
				centeredSlides: true,
				loop: true,
				speed: 600,

				navigation: {
					prevEl: blogContainer.querySelector('.swiper-button-prev'),
					nextEl: blogContainer.querySelector('.swiper-button-next'),
				},

				autoplay: {
					delay: 5000,
					disableOnInteraction: false,
				},

				grabCursor: true,
			});

			swiperInstances.set(blogContainer, swiper);
		}

		// ❌ Destroy on desktop
		else if (window.innerWidth > 768 && blogInstance) {

			blogInstance.destroy(true, true);
			swiperInstances.delete(blogContainer);

			blogContainer.classList.remove('swiper');
			blogList.classList.remove('swiper-wrapper');

			[...blogItems].forEach(item => {
				item.classList.remove('swiper-slide');
			});
		}
	}

}

// Add listeners (with a debounce for performance)
let resizeTimeout;
window.addEventListener('load', initSwiper);
window.addEventListener('resize', () => {
	clearTimeout(resizeTimeout);
	resizeTimeout = setTimeout(initSwiper, 200);
});


// override carousel slider plugin
function styleDelkimFamilySlider() {
  const slider = document.querySelector('.delkim-family-slider .swiper');
  if (!slider || !slider.swiper) return;

  const swiper = slider.swiper;

  if (window.innerWidth <= 768) {
    swiper.params.slidesPerView = 1.5;     
    swiper.params.centeredSlides = true;
    swiper.params.spaceBetween = 16;      
    swiper.update();
  } else {
    // Restore desktop behavior from plugin
    swiper.params.slidesPerView = 3;     
    swiper.params.centeredSlides = false;
    swiper.params.spaceBetween = 15;
    swiper.update();
  }
}

window.addEventListener('load', styleDelkimFamilySlider);
window.addEventListener('resize', styleDelkimFamilySlider);

const latestPostsSwipers = new WeakMap();

function initLatestPostsSwiper() {
  const lists = document.querySelectorAll('.wp-block-latest-posts');

  lists.forEach(list => {
    const existing = latestPostsSwipers.get(list);

    if (window.innerWidth <= 768 && !existing) {
      list.classList.add('swiper');

      const wrapper = document.createElement('div');
      wrapper.className = 'swiper-wrapper';

      // Move all <li> into the wrapper
      const slides = Array.from(list.children);
      slides.forEach(li => {
        li.classList.add('swiper-slide');
        wrapper.appendChild(li);
      });

      list.appendChild(wrapper);

      // Kill Gutenberg grid behavior
      list.style.display = 'block';
      list.style.gridTemplateColumns = 'none';

      // Wrap in a container for arrows
      const parent = list.parentElement;
      const outer = document.createElement('div');
      outer.className = 'latest-posts-swiper-wrapper';
      parent.insertBefore(outer, list);
      outer.appendChild(list);

      const prevBtn = document.createElement('div');
      prevBtn.className = 'swiper-button-prev';
      outer.appendChild(prevBtn);

      const nextBtn = document.createElement('div');
      nextBtn.className = 'swiper-button-next';
      outer.appendChild(nextBtn);

	  const pagination = document.createElement('div');
	  pagination.className = 'swiper-pagination';
	  outer.appendChild(pagination);

      const swiper = new Swiper(list, {
        centeredSlides: true,
        slidesPerView: 1.3,
        spaceBetween: 16,
        speed: 2000,
        loop: true,
        autoplay: {
          delay: 5000,
          disableOnInteraction: false,
        },
        keyboard: {
          enabled: true,
          onlyInViewport: false,
        },
		 pagination: {
			el: pagination,
			clickable: true,
		},
        grabCursor: true,
      });

      latestPostsSwipers.set(list, swiper);
      console.log('✅ Latest posts swiper initialized');
    }

    // ❌ DESKTOP: destroy
    else if (window.innerWidth > 768 && existing) {
      existing.destroy(true, true);
      latestPostsSwipers.delete(list);

      //Restore original UL structure
      const wrapper = list.querySelector('.swiper-wrapper');
      if (wrapper) {
        const slides = Array.from(wrapper.children);
        slides.forEach(li => {
          li.classList.remove('swiper-slide');
          list.appendChild(li);
        });
        wrapper.remove();
      }

      list.classList.remove('swiper');

      //Remove outer wrapper & arrows
      const outer = list.closest('.latest-posts-swiper-wrapper');
      if (outer) {
        outer.replaceWith(list);
      }

      //Restore Gutenberg grid
      list.style.display = '';
      list.style.gridTemplateColumns = '';
    }
  });
}

window.addEventListener('load', initLatestPostsSwiper);
window.addEventListener('resize', initLatestPostsSwiper);

